import Actions from "./constants";
import { IActionObject } from "./types";

export function setYouVisitAnalyticsConfig(data: object): IActionObject {
  return { type: Actions.SET_ANALYTICS_CONFIG, data };
}

export function setIsRegistered(): IActionObject {
  return { type: Actions.SET_IS_REGISTERED };
}

export function setPersonalizationEnabled(data: boolean): IActionObject {
  return { type: Actions.SET_PERSONALIZATION_ENABLED, data };
}

export function setExperienceOffline(data: boolean): IActionObject {
  return { type: Actions.SET_EXPERIENCE_OFFLINE, data };
}

export function setExperienceNotFound(data: boolean): IActionObject {
  return { type: Actions.SET_EXPERIENCE_NOT_FOUND, data };
}

export default {
  setYouVisitAnalyticsConfig,
};
try {
    // @ts-ignore
    setYouVisitAnalyticsConfig.displayName = "setYouVisitAnalyticsConfig";
    // @ts-ignore
    setYouVisitAnalyticsConfig.__docgenInfo = { "description": "", "displayName": "setYouVisitAnalyticsConfig", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/YouVisitAnalytics/store/actions.ts#setYouVisitAnalyticsConfig"] = { docgenInfo: setYouVisitAnalyticsConfig.__docgenInfo, name: "setYouVisitAnalyticsConfig", path: "src/shared/hoc/YouVisitAnalytics/store/actions.ts#setYouVisitAnalyticsConfig" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setPersonalizationEnabled.displayName = "setPersonalizationEnabled";
    // @ts-ignore
    setPersonalizationEnabled.__docgenInfo = { "description": "", "displayName": "setPersonalizationEnabled", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/YouVisitAnalytics/store/actions.ts#setPersonalizationEnabled"] = { docgenInfo: setPersonalizationEnabled.__docgenInfo, name: "setPersonalizationEnabled", path: "src/shared/hoc/YouVisitAnalytics/store/actions.ts#setPersonalizationEnabled" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setExperienceOffline.displayName = "setExperienceOffline";
    // @ts-ignore
    setExperienceOffline.__docgenInfo = { "description": "", "displayName": "setExperienceOffline", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/YouVisitAnalytics/store/actions.ts#setExperienceOffline"] = { docgenInfo: setExperienceOffline.__docgenInfo, name: "setExperienceOffline", path: "src/shared/hoc/YouVisitAnalytics/store/actions.ts#setExperienceOffline" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    setExperienceNotFound.displayName = "setExperienceNotFound";
    // @ts-ignore
    setExperienceNotFound.__docgenInfo = { "description": "", "displayName": "setExperienceNotFound", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/YouVisitAnalytics/store/actions.ts#setExperienceNotFound"] = { docgenInfo: setExperienceNotFound.__docgenInfo, name: "setExperienceNotFound", path: "src/shared/hoc/YouVisitAnalytics/store/actions.ts#setExperienceNotFound" };
}
catch (__react_docgen_typescript_loader_error) { }